import { MessageBlock, MessageBlockType } from '@triumph/design-system';
import { useTranslation } from 'react-i18next';
import { AccessDeniedWrapper } from './AccessDenied.StyledComponents';

export const AccessDenied: React.FC = () => {
  const { t } = useTranslation('accessDenied');

  return (
    <AccessDeniedWrapper>
      <MessageBlock
        message={t('message')}
        type={MessageBlockType.warning}
        messageId={0}
        show={true}
        width="auto"
      />
    </AccessDeniedWrapper>
  );
};
